// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f"}[chunkId] || chunkId) + "." + {"83":"dd687e7873531f03","316":"83f2bbcd93d01219","457":"e97e477000b4ad73","501":"d13bf505216111a2","839":"852c6c7e965ce7ee"}[chunkId] + ".js";
};